module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{"author":"/people/samantha-smith/"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/authors-samantha-smith.json
// module id = 1643
// module chunks = 277133744887648